import { Stack, Typography } from '@mui/material';

interface RecommendationLockupProps {
    recommendationType: string;
    title: string;
    subtitle: string;
}

function RecommendationLockup({ recommendationType, title, subtitle }: RecommendationLockupProps) {
    return (
        <Stack py={4} spacing={1}>
            <Typography variant='overline' color='primary.mui.inactive' textTransform='uppercase'>
                {recommendationType}
            </Typography>
            <Typography variant='h5' color='primary'>
                {title}
            </Typography>
            <Typography variant='body1' color='primary'>
                {subtitle}
            </Typography>
        </Stack>
    );
}

export default RecommendationLockup;
